"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bosDealerFragment = void 0;
exports.bosDealerFragment = `
  fragment bosDealer on BosDealer {
    bankAccountNo
    dealerId
    id
    mapRefLatitude
    mapRefLongitude
    name
    partitionKey
    postalAddressStreet
    postalAddressZipCode
    postalAddressCity
    timestamp
    type
    visitingAddressStreet
    visitingAddressZipCode
    visitingAddressCity
  }
`;
//# sourceMappingURL=dealer.js.map